// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__7jMsI","col":"styles_col__25QqP"};